const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change'
};

(function () {
  'use strict';

  function addBundleSeparatorStyles() {
    if (document.getElementById('nz-bundle-separator-style')) return;

    var style = document.createElement('style');
    style.id = 'nz-bundle-separator-style';
    style.textContent = `
      #MainContent .nz2-main-product .nz-bundle__label {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 14px !important;
        width: 100% !important;
        margin: 0 0 9px !important;
        color: #010142 !important;
        font-size: 11px !important;
        line-height: 1.3 !important;
        font-weight: 800 !important;
        letter-spacing: 2px !important;
        text-align: center !important;
      }

      #MainContent .nz2-main-product .nz-bundle__label::before,
      #MainContent .nz2-main-product .nz-bundle__label::after {
        content: '';
        display: block;
        width: 48px;
        height: 1px;
        background: #d9dbea;
      }

      #MainContent .nz2-main-product .nz-bundle__helper {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 7px !important;
        max-width: 440px !important;
        margin: 0 auto 18px !important;
        color: #010142 !important;
        font-size: 10px !important;
        line-height: 1.4 !important;
        font-weight: 650 !important;
        letter-spacing: 0 !important;
        text-align: left !important;
      }

      #MainContent .nz2-main-product .nz-bundle-savings-tick {
        display: inline-flex !important;
        width: 18px !important;
        height: 18px !important;
        min-width: 18px !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 18px !important;
        border-radius: 999px !important;
        background: #010142 !important;
        color: #ffffff !important;
      }

      #MainContent .nz2-main-product .nz-bundle-savings-tick svg {
        display: block !important;
        width: 12px !important;
        height: 12px !important;
        overflow: visible !important;
        color: #ffffff !important;
      }

      #MainContent .nz2-main-product .nz-bundle-savings-copy {
        display: inline !important;
        min-width: 0 !important;
      }

      #MainContent .nz2-main-product .nz-bundle-savings-title {
        font-size: 9.5px !important;
        line-height: 1.35 !important;
        font-weight: 800 !important;
        letter-spacing: .55px !important;
        text-transform: none !important;
      }

      #MainContent .nz2-main-product .nz-bundle-savings-detail {
        font-size: 9.5px !important;
        line-height: 1.35 !important;
        font-weight: 600 !important;
        letter-spacing: 0 !important;
      }

      @media screen and (max-width: 749px) {
        #MainContent .nz2-main-product .nz-bundle__label {
          gap: 10px !important;
          font-size: 10px !important;
          letter-spacing: 1.6px !important;
        }

        #MainContent .nz2-main-product .nz-bundle__label::before,
        #MainContent .nz2-main-product .nz-bundle__label::after {
          width: 30px;
        }

        #MainContent .nz2-main-product .nz-bundle__helper {
          gap: 6px !important;
          max-width: 330px !important;
          margin-bottom: 16px !important;
          font-size: 9px !important;
          line-height: 1.35 !important;
        }

        #MainContent .nz2-main-product .nz-bundle-savings-tick {
          width: 17px !important;
          height: 17px !important;
          min-width: 17px !important;
          flex-basis: 17px !important;
        }

        #MainContent .nz2-main-product .nz-bundle-savings-tick svg {
          width: 11px !important;
          height: 11px !important;
        }

        #MainContent .nz2-main-product .nz-bundle-savings-title,
        #MainContent .nz2-main-product .nz-bundle-savings-detail {
          font-size: 9px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function applyBundleSavingsMarkup() {
    document.querySelectorAll('#MainContent .nz2-main-product .nz-bundle__helper').forEach(function (helper) {
      if (helper.dataset.nzBundleSavingsDirect === '1') return;

      helper.dataset.nzBundleSavingsDirect = '1';
      helper.innerHTML =
        '<span class="nz-bundle-savings-tick" aria-hidden="true">' +
          '<svg viewBox="0 0 20 20" focusable="false">' +
            '<path d="M4.4 10.3l3.3 3.3 7.9-7.9" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"></path>' +
          '</svg>' +
        '</span>' +
        '<span class="nz-bundle-savings-copy">' +
          '<span class="nz-bundle-savings-title">bundle savings available now</span>' +
          '<span class="nz-bundle-savings-detail"> — Secure your supply before current pricing is updated.</span>' +
        '</span>';
    });
  }

  function initialiseBundleSavings() {
    addBundleSeparatorStyles();
    applyBundleSavingsMarkup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseBundleSavings, { once: true });
  } else {
    initialiseBundleSavings();
  }

  var bundleObserver = new MutationObserver(function () {
    window.requestAnimationFrame(applyBundleSavingsMarkup);
  });

  if (document.documentElement) {
    bundleObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function () {
    window.requestAnimationFrame(initialiseBundleSavings);
  });
})();